import { Box, Button } from "@mui/material";
import { useParams, useLocation } from "react-router-dom";
import { useContent } from "../../logic";
import { useGetOrder } from "../../logic/useApiQuery";
import { formatClosingDate, getCalEndDate, getCalStartDate, toTitleCase } from "../../utils";
import { isAdhocPortalOrder } from "../../utils/isAdhocPortalOrder";
import { AddToCalendarDialog } from "./AddToCalendar";
import { ADDRESS_CHARS_REGEX } from "./ClosingHeader";

export type CalEventType = {
  name: string,
  details: string,
  location: string,
  startsAt: string,
  endsAt: string,
}

interface ClsoingHeaderActionsProps {
  setClosingDetailsDialogOpen: (open: boolean) => void;
  addToCalendarOpen: boolean;
  setAddToCalendarOpen: (open: boolean) => void;
}

export function ClosingHeaderActions({setClosingDetailsDialogOpen, addToCalendarOpen, setAddToCalendarOpen} : ClsoingHeaderActionsProps) {
  const { closingId } = useParams()
  const { search } = useLocation()
  const { data: globalOrderData } = useGetOrder(closingId ?? '', search ?? '')
  const { SigningDetailsText } = useContent()

  if (!globalOrderData) {
    return null
  }

  if (isAdhocPortalOrder(globalOrderData.Order)) {
    return null
  }

  const time = formatClosingDate({ order: globalOrderData.Order })
  const closingAddress = globalOrderData.Order.ClosingAddress
  const hasFullAddress = ADDRESS_CHARS_REGEX.test(closingAddress.Full || '')

  const hasGranularAddress =
    ADDRESS_CHARS_REGEX.test(closingAddress.Street || '') &&
    ADDRESS_CHARS_REGEX.test(closingAddress.City || '') &&
    ADDRESS_CHARS_REGEX.test(closingAddress.State || '') &&
    ADDRESS_CHARS_REGEX.test(closingAddress.Zip || '')

  const allClosingDetailsHTML = globalOrderData.Order.ClosingDetails?.AllClosingDetailsHTML
  const hasAnyDetails = ((hasFullAddress || hasGranularAddress) || time || allClosingDetailsHTML)
  const hasParseableTime = !!getCalStartDate(globalOrderData.Order)

  const propertyAddress = globalOrderData.Order.PropertyAddress
  const propertyAddressName = propertyAddress?.Street || propertyAddress?.Full
  const calStartDate = getCalStartDate(globalOrderData.Order)

  const calEvent: CalEventType = {
    name: propertyAddressName ? `Signing - ${propertyAddressName}` : 'Signing',
    details: '',
    location: closingAddress?.Full,
    startsAt: calStartDate,
    endsAt: getCalEndDate(calStartDate),
  }

  return <Box sx={{ height: '90px', display: 'flex', ml: 'auto', flexBasis: '40%', maxWidth: '270px'  }}>
    {hasAnyDetails ?
      <Button
        sx={{
          height: '40px', bgcolor: 'white', margin: 'auto', flexGrow: 2,
          borderRadius: '100px',
          '&:hover': { bgcolor: 'primary.dark', color: 'white', border: 'none' },
        }}
        onClick={() => setClosingDetailsDialogOpen(true)} variant="outlined"
      >
        <Box sx={{  }}>{toTitleCase(SigningDetailsText)}</Box>
      </Button> : ''
    }

    <AddToCalendarDialog
      event={calEvent}
      setAddToCalendarOpen={setAddToCalendarOpen}
      addToCalendarOpen={addToCalendarOpen && hasParseableTime}
    />


  </Box>
}
